import { motion } from "framer-motion";

export default function FoodCard({ name, image, description, macronutrient }) {
  return (
    <motion.div
      className="food-card"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      layout
    >
      <img
        src={image}
        alt={name}
        style={{
          borderRadius: "8px",
          width: "100%",
          height: "150px",
          objectFit: "cover",
        }}
        onError={(e) => (e.target.style.display = "none")}
      />
      <h3>{name}</h3>
      <p>{description}</p>
      <p>
        <strong>Macronutriments:</strong>{" "}
        {Array.isArray(macronutrient)
          ? macronutrient.join(", ")
          : macronutrient}
      </p>
    </motion.div>
  );
}
